import axios from "@/api/axiosInstance";
import { SaveKPIThresholdRequest, SaveKPIThresholdResponse } from "./types";

/** Creates or replaces one KPI's thresholds on the active company. */
export const saveKPIThreshold = async (
  kpiCode: string,
  request: SaveKPIThresholdRequest,
): Promise<SaveKPIThresholdResponse> => {
  const response = await axios.put<SaveKPIThresholdResponse>(
    `/api/private/kpi-dashboard/thresholds/${kpiCode}`,
    request,
  );
  return response.data;
};
